export default __webpack_public_path__ + "static/media/image6.20daacc3.svg";